import * as types from '../../types';
import { Species } from '../../types/gql-op-types';

/** The white-background shop renders exist for these s3 band colors only. */
const S3_HERO_COLORS: string[] = [
  types.ColorOption.Blue,
  types.ColorOption.Gray,
  types.ColorOption.Pink,
  types.ColorOption.Yellow,
];

const DESCRIPTORS = ['1500w', '3000w'];

/**
 * The image the hardware-first page opens the Mini gallery with. The standalone pdps keep the
 * grey-ground photography, so these renders sit in their own directory rather than replacing
 * `mini-01-*` / `circle-*`.
 */
export const HARDWARE_FIRST_MINI_HERO: types.IImage = {
  type: 'image',
  url: '/product_images/hardware-first/mini.jpg',
  descriptors: DESCRIPTORS,
};

/**
 * The Mini gallery's dog-over-the-shoulder frame, at full size. Both redesigned pages open the Mini
 * gallery on it, and the gallery drops its own copy rather than showing it twice.
 */
const MINI_DOG_LIFESTYLE_HERO: types.IImage = {
  type: 'image',
  url: '/product_images/mini/mini-03-dog.jpg',
  descriptors: ['1500w', '3000w', '4000w'],
};

/** The lifestyle shot the solo product page opens its gallery with; cats have their own. */
export function hardwareFirstLifestyleHero(deviceKey: 'mini' | 's3' | 'ultra', species: Species): types.IImage {
  if (deviceKey === 'mini' && species !== Species.CAT) {
    return MINI_DOG_LIFESTYLE_HERO;
  }
  const key = species === Species.CAT ? 'cat' : deviceKey;
  return { type: 'image', url: `/product_images/hardware-first/lifestyle-${key}.webp` };
}

/**
 * The lifestyle shot the redesigned lineup page opens the Mini and s3 galleries with, so the hero
 * and the tracker card beside it do not show the same render. Ultra keeps its gallery's opening photo.
 */
export function hardwareFirstLineupHero(
  deviceKey: 'mini' | 's3' | 'ultra',
  species: Species,
): types.IImage | undefined {
  if (deviceKey === 'ultra') {
    return undefined;
  }
  return hardwareFirstLifestyleHero(deviceKey, species);
}

/** The s3 layflat for `variant`, or undefined for a color with no white-background render. */
export function hardwareFirstS3Hero(variant?: types.IVariant): types.IImage | undefined {
  const color = variant?.options.color;
  if (!color || !S3_HERO_COLORS.includes(color)) {
    return undefined;
  }
  return { type: 'image', url: `/product_images/hardware-first/s3-${color}.jpg`, descriptors: DESCRIPTORS };
}
